import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import { BizDevelopmentDashboardMobileEndPointLogic } from "../../../../logic/BizDevelopment/Dashboard/BizDevelopmentDashboardMobileEndPointLogic";
import {
  setMobileComparisonQueryOutput,
  setMobileComparisonFetchedFor,
} from "../../../../features/bizDevelopmentDashboardMobileSlice";
import store from "../../../../store";
import {
  BIZ_DEVELOPMENT_BUDGET_QUERY_ID,
  BIZ_DEVELOPMENT_BUDGET_LAST_RUN_QUERY_ID,
} from "../QueryIDsBizDevelopmentDashboard";

export const useBizDevelopmentDashboardMobile = () => {
  const [searchParams] = useSearchParams();
  const userData = useSelector(selectUserData);
  const oauthTokenHeader = userData?.data?.oauth_token;

  const getSiteFromWorkspace = (): string[] => {
    const workspaceId = searchParams.get("workspace");
    return workspaceId ? workspaceId.split(",").filter(Boolean) : [];
  };

  const getTimeframeFromParams = (): string => {
    return searchParams.get("timeframePerformance") || "yesterday";
  };

  const fetchDashboardData = async (
    timeframe?: string,
    siteSharedUids?: string[],
  ) => {
    const resolvedTimeframe = timeframe ?? getTimeframeFromParams();
    const resolvedSites = siteSharedUids ?? getSiteFromWorkspace();
    if (resolvedSites.length === 0) return;

    await BizDevelopmentDashboardMobileEndPointLogic.getDashboardData(
      oauthTokenHeader,
      resolvedSites,
      resolvedTimeframe,
    );
  };

  const fetchComparisonData = async (
    timeframe: string,
    siteSharedUids?: string[],
  ) => {
    const resolvedSites = siteSharedUids ?? getSiteFromWorkspace();
    if (resolvedSites.length === 0) return;

    await BizDevelopmentDashboardMobileEndPointLogic.getComparisonDashboardData(
      oauthTokenHeader,
      resolvedSites,
      timeframe,
    );
  };

  const clearComparisonData = () => {
    store.dispatch(setMobileComparisonQueryOutput([]));
    store.dispatch(setMobileComparisonFetchedFor(null));
  };

  const fetchBudgetData = async (siteSharedUids?: string[]) => {
    const resolvedSites = siteSharedUids ?? getSiteFromWorkspace();
    if (resolvedSites.length === 0) return;
    // Fire budget data and brand last-run queries simultaneously
    await Promise.all([
      BizDevelopmentDashboardMobileEndPointLogic.getBizMobileBudgetData({
        oauthTokenHeader,
        queryId: BIZ_DEVELOPMENT_BUDGET_QUERY_ID,
        websiteSharedUids: resolvedSites,
        type: "site",
        dimension: ["bbb_uk"],
      }),
      BizDevelopmentDashboardMobileEndPointLogic.getBudgetCardBrandLastRunQueryInBizDevDashboardMobile(
        {
          oauthTokenHeader,
          queryId: BIZ_DEVELOPMENT_BUDGET_LAST_RUN_QUERY_ID,
          websiteSharedUids: resolvedSites,
          type: "site",
          dimension: ["bbb_uk"],
        },
      ),
    ]);
  };

  return {
    fetchDashboardData,
    fetchComparisonData,
    clearComparisonData,
    fetchBudgetData,
    getSiteFromWorkspace,
    getTimeframeFromParams,
  };
};
